const ACCESS_ERROR_PATTERNS = [
  /active subscription or enough credits/i,
  /not enough credits/i,
  /payment required/i,
  /requires subscription/i,
];

export function toPredictionAccessPopup(error, t) {
  const message = String(error?.message || "").trim();
  const shouldShowPopup = ACCESS_ERROR_PATTERNS.some((pattern) => pattern.test(message));

  if (!shouldShowPopup) {
    return { shouldShowPopup: false, title: "", message };
  }

  return {
    shouldShowPopup: true,
    title: t("payment_required_title"),
    message: message || t("payment_required_body"),
  };
}
